import { useEffect, useRef, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import Portal from "./PortalModal"
import { Building2 } from "lucide-react"


export default function SwitchOrgModal({
    open,
    title,
    items = [],
    loading,
    hasMore,
    onSearch,
    onLoadMore,
    onSelect,
    onClose,
}) {
    const listRef = useRef(null)
    const [keyword, setKeyword] = useState('')
    const [selectedOrg, setSelectedOrg] = useState(null)

    useEffect(() => {
        if (open) {
            console.log('open items', items)
            setSelectedOrg(null)
            setKeyword('')
        }
    }, [open])


    // detect scroll bottom
    useEffect(() => {
        if (!open) return
        const el = listRef.current
        if (!el) return

        const onScroll = () => {
            if (
                el.scrollTop + el.clientHeight >=
                el.scrollHeight - 40
            ) {
                if (!loading && hasMore) {
                    onLoadMore?.()
                }
            }
        }

        el.addEventListener('scroll', onScroll)
        return () => el.removeEventListener('scroll', onScroll)
    }, [open, loading, hasMore, onLoadMore])

    return (
        <AnimatePresence>
            {open && (
                <Portal>
                    <motion.div
                        className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                    >
                        <motion.div
                            className="bg-white rounded-2xl w-full max-w-md p-6 space-y-4"
                            initial={{ scale: .96, opacity: 0 }}
                            animate={{ scale: 1, opacity: 1 }}
                            exit={{ scale: .96, opacity: 0 }}
                        >
                            <h3 className="text-lg font-semibold">{title}</h3>

                            {/* Search */}
                            <div className="flex gap-2">
                                <input
                                    value={keyword}
                                    onChange={e => setKeyword(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && onSearch?.(keyword)}
                                    placeholder="ค้นหาองค์กร..."
                                    className="w-full px-3 py-2 border border-gray-200 rounded-md text-sm focus:ring-2 focus:ring-primary focus:outline-none"
                                />
                                <button
                                    onClick={() => onSearch?.(keyword)}
                                    className="px-4 rounded-md bg-primary text-white text-sm"
                                >
                                    ค้นหา
                                </button>
                            </div>

                            {/* List */}
                            <div
                                ref={listRef}
                                className="space-y-2 max-h-72 overflow-auto"
                            >
                                {items.map(org => {
                                    const isActive =
                                        (selectedOrg?.membership_id && selectedOrg.membership_id === org.membership_id) ||
                                        (selectedOrg?.org_id && selectedOrg.org_id === org.org_id) ||
                                        (selectedOrg?.organization_id && selectedOrg.organization_id === org.organization_id)


                                    return (
                                        <button
                                            key={org.membership_id || org.org_id || org.organization_id}
                                            type="button"
                                            onClick={() => setSelectedOrg(org)}
                                            className={`w-full flex items-center gap-4 p-4 rounded-2xl border-2 transition
                                                ${isActive
                                                    ? 'border-primary bg-primary/5'
                                                    : 'border-gray-200 hover:border-primary/40'}
                                            `}
                                        >
                                            <Building2 size={24} className={isActive ? 'text-primary' : ''} />

                                            <div className="text-left">
                                                <div className="font-medium">
                                                    {org.org_name_th || org.name_th}
                                                </div>
                                                <div className="text-xs text-gray-500">
                                                    {org.org_name_en || org.name_en}
                                                </div>
                                            </div>
                                        </button>
                                    )
                                })}


                                {loading && (
                                    <div className="text-center text-sm text-gray-400 py-4">
                                        กำลังโหลด...
                                    </div>
                                )}

                                {!loading && !items.length && (
                                    <div className="text-center text-sm text-gray-400 py-6">
                                        ไม่พบข้อมูล
                                    </div>
                                )}
                            </div>

                            <div className="mt-4 flex justify-end gap-2">
                                <button
                                    type="button"
                                    onClick={onClose}
                                    className="py-2 px-3 rounded-md bg-gray-100"
                                >
                                    ยกเลิก
                                </button>

                                <button
                                    type="button"
                                    disabled={!selectedOrg}
                                    onClick={() => {
                                        if (!selectedOrg) return
                                        onSelect?.(selectedOrg)
                                    }}
                                    className={`py-2 px-4 rounded-md text-white transition
                                            ${selectedOrg
                                            ? 'bg-primary hover:bg-primary/90'
                                            : 'bg-gray-300 cursor-not-allowed'}
                                    `}
                                >
                                    ยืนยัน
                                </button>
                            </div>

                        </motion.div>
                    </motion.div>
                </Portal>
            )}
        </AnimatePresence>
    )
}
